<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :data="content"
      :tabId="tabId"
      :sellers="sellers"
      :selectProduct="selectProduct"
      :producWarhouse="producWarhouse"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @search="search"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      @getRowDetail="getRowDetail"
      @emtyTabId="emtyTabId"
    ></div-table>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      configList: config.list,
      selected: [],
      tabId:[],
      loading: false,
      content: {},
      products: [],
      filters:{limit:100},
      categories: [],
      sellers: [],
      statusOrder: [],
      //currentUser: {},
      selectProduct:{},
      producWarhouse:[],
      limit: 100,
     // idWharhouse:null,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected(){
          return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
      },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {
         //  await this.getwharhouseId();
          // await this.reset();
         
      },
      'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          if(this.currentUser.type != "Admin") {this.limit=10;this.filters.limit=10}
          await this.reset();
          if (this.currentUser.type != "Seller") {await this.getSellers(); this.setDataSelect("seller", this.sellers, null);}
      }
  },
  async mounted() {
   // await this.getUser();
   // await this.getwharhouseId();
     if(this.currentUser.type != "Admin") {this.limit=10;this.filters.limit=10}

     if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
     else this.$f.objectToQueryString({limit:this.limit})

    if(this.filters.name) await this.search(this.filters.name);
    else await this.setProducts(this.filters);

    //await this.getCategories();
    if (this.currentUser && this.currentUser.type && this.currentUser.type == "Seller") {
      //this.filters.splice(1, 1);
      this.setDataSelect("seller", this.sellers, "yes");
         let pos = this.configList.columns.map(function (e) {
                        return e.name;
                        }).indexOf('Seller');
            if(pos!=-1)  this.configList.columns.splice(pos, 1);  
    } else {
      await this.getSellers();
      //this.filters[1].values = this.sellers;
      this.setDataSelect("seller", this.sellers, null);
    }

    //this.filters[0].values = this.categories;
    this.setDataSelect("category", this.categories, null);
  },

  methods: {
     async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
     async getRowDetail(item, id) {
        // let rows = this.selectedRows;
        console.log('.rowCheckboxProduct-'+id)
        let columns = document.querySelectorAll('.rowCheckbox');
        let element = document.querySelector('.rowCheckboxProduct-'+id);

        if (this.tabId.length>0) { 
           this.tabId = [];
           columns.forEach(column => {column.checked = false});
        }
        element.checked = true;

        let itemInRow = this.tabId.filter(item => item === id);
        let isItemInRow = itemInRow.length > 0;
            
        if (isItemInRow) { 
            let pos = this.tabId.map(function (e) {return e;}).indexOf(id);
            this.tabId.splice(pos, 1);
        } else {
            this.tabId.push(id);
            const search = { _id: id };
            const res = await this.$server.find("products", search);
            if(res.content.results){
                 this.selectProduct=res.content.results[0];
                // this.producWarhouse=this.$f.getElementInArray(this.selectProduct.details,this.idWharhouse._id) ;
                 this.producWarhouse=this.selectProduct.details;
            }
            
        }
    
    },
    emtyTabId(){
      let columns = document.querySelectorAll('.rowCheckbox');
      columns.forEach(column => {column.checked = false});
      this.tabId = [];
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    setUserId(filters) {
      return (filters.seller = this.currentUser._id);
    },
    async getProducts(filters) {
      //filters=this.setUserId();
      filters['details.warehouse']=this.idWharhouse._id;
      const res = await this.$server.search("products", filters);
      if (res.content.results) {
        this.products = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else{this.products = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}} 
    },

    async setProducts(filter) {
      this.loading = true;
      await this.getProducts(filter);
      this.loading = false;
      let products = this.products;
      console.log("products", products);
      for (let i in products) {
        let qty = products[i].quantity;
        // if(qty.inStock) products[i].inStock = qty.inStock;
        // if(qty.total) products[i].total = qty.total;
        // if(qty.defective) products[i].defective = qty.defective;
        // if (products[i].category) products[i].category = products[i].category.name;
        if (products[i].seller) products[i].seller = products[i].seller.fullName||products[i].seller.email;
      }
      this.content = products;
    },

    async refresh() {
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        this.$f.objectToQueryString(this.filters)
        if(this.filters.name) await this.search(this.filters.name);
        else await this.setProducts(this.filters);
        if(this.filters['page'] && this.filters['page']>1 && this.content.length==0){
          this.filters['page']= --this.filters['page'];
           this.$f.objectToQueryString(this.filters)
          await this.setProducts(this.filters);
       }
    },

    /*********************************************************************************/
    async reset(data) {
      let lmitt=this.limit;
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      if(this.filters['limit']) lmitt=this.filters['limit'];
       this.filters['page']=1;
      this.$f.objectToQueryString({limit:lmitt})
      await this.setProducts({limit:lmitt});
    },
    async search(data) {
      this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
       let limitt=this.limit
       if(this.filters['limit']) limitt=this.filters['limit'];

      const search = { name: data.trim(), limit:parseInt(limitt) };
      
      search['details.warehouse']=this.idWharhouse._id;
      this.$f.objectToQueryString(search)
      this.loading = true;
      let resproduct = await this.$server.find("products", search);
      this.loading = false;

      let resultProduct = [];
      if (resproduct.content && resproduct.content != "no products found") {
        resultProduct = resproduct.content.results;
      for (let k in resultProduct) {
        const qty = resultProduct[k].quantity;
        // resultProduct[k].inStock = qty.inStock;
        // resultProduct[k].total = qty.total;
        // resultProduct[k].defective = qty.defective;
        if (resultProduct[k].seller) resultProduct[k].seller = resultProduct[k].seller.fullName||resultProduct[k].seller.email;
      }
        this.content = resultProduct;
      } else this.content = [];
    },
    async filtrer(data) {
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       delete  this.filters.page;
       delete  this.filters.name;

       if(!this.filters['limit']) this.filters['limit']=this.limit;
       if(data.quantity) this.filters["quantity.inStock"]=data.quantity;else delete this.filters["quantity.inStock"];
       if(data.price) this.filters.price=data.price;else delete this.filters.price;
       if(data.createdAt) this.filters.createdAt=data.createdAt;else delete this.filters.createdAt;
       this.paginate.currentpage=1;

      if (data.seller) this.filters.seller = data.seller._id;else delete this.filters.seller;
      this.$f.objectToQueryString(this.filters)
      await this.setProducts(this.filters);
    },
    /****************************************************************************/
    async getCategories() {
      const res = await this.$server.search("categories");
      if (res.content.results) this.categories = res.content.results;
      else this.categories = [];
    },
    async getSellers() {
      const filter = {
         type: "Seller",
         warehouses:this.idWharhouse._id,
         limit:10,
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = [];
      //console.log(this.currentUser);
    },
    /***************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.filters['page']=page;
      this.$f.objectToQueryString(this.filters)

      this.setProducts(this.filters);
    },
  },
};
</script>

<style>
</style>




